import { render, staticRenderFns } from "./Overview2.vue?vue&type=template&id=453509c0&scoped=true&"
import script from "./Overview2.vue?vue&type=script&lang=ts&"
export * from "./Overview2.vue?vue&type=script&lang=ts&"
import style0 from "./Overview2.vue?vue&type=style&index=0&id=453509c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453509c0",
  null
  
)

export default component.exports